import * as z$1 from "zod/v4";
//#region src/schemas/agent-controller-permission-mode.ts
const agentControllerPermissionModeSchema = z$1.enum([
	"claude-code:default",
	"claude-code:acceptEdits",
	"claude-code:plan",
	"claude-code:auto",
	"claude-code:dontAsk",
	"claude-code:bypassPermissions",
	"codex:askForApproval",
	"codex:approveForMe",
	"codex:fullAccess",
	"codex:customConfig",
	"cursor:default",
	"cursor:plan",
	"cursor:ask",
	"cursor:autoReview",
	"cursor:force",
	"grok-build:default",
	"grok-build:acceptEdits",
	"grok-build:plan",
	"grok-build:auto",
	"grok-build:dontAsk",
	"grok-build:bypassPermissions"
]);
//#endregion
export { agentControllerPermissionModeSchema };

//# sourceMappingURL=agent-controller-permission-mode.js.map